<template>
    <div class="p-grid">
        <Toast />
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Account.Editinfo1.Header') }}</strong>
                </h4>
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-5">
                        <label for="nameuser">{{ $t('Account.Editinfo1.name') }}</label>
                        <InputText id="nameuser" :class="`${error.name ? 'p-invalid' : ''}`" type="text"
                            :placeholder="$t('Account.Editinfo1.name')" v-model="name" />
                        <div class="text-red">{{ error.name }}</div>
                    </div>
                </div>
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-5">
                        <label for="nameuser">{{ $t('Account.Editinfo1.password') }}</label>
                        <InputText id="nameuser" :class="`${error.password ? 'p-invalid' : ''}`" type="text"
                            :placeholder="$t('Account.Editinfo1.password')" v-model="password" />
                        <div class="text-red">{{ error.password }}</div>
                    </div>
                </div>
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-5">
                        <label for="emailuser">{{ $t('Account.Editinfo1.e-mail') }}</label>
                        <InputText id="emailuser" type="text" placeholder="User_Id" v-model="email" disabled />
                    </div>
                </div>
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-5">
                        <label for="emailuser">{{ $t('Account.Editinfo1.Contact') }}</label>
                        <InputText id="emailuser" :class="`${error.phone_number ? 'p-invalid' : ''}`" type="text"
                            :placeholder="$t('Account.Editinfo1.Contact')" v-model="phone_number"
                            onkeypress="return /[0-9]/i.test(event.key)" maxlength="10" />
                        <div class="text-red">{{ error.phone_number }}</div>
                    </div>
                </div>
                <!-- <div class="p-d-flex p-jc-end">
                    <ConfirmPopup group="popup"></ConfirmPopup>
                    <Button @click="cancel" icon="pi pi-times" label="Cancel" class="p-mr-2"></Button>
                    <Button ref="popup" @click="confirm($event)" icon="pi pi-check" label="Confirm" class="p-mr-2"></Button>
                </div> -->
                <div class="p-d-flex p-jc-between">
                    <ConfirmPopup group="popup"></ConfirmPopup>
                    <Button label="Primary" class="p-button-outlined p-mr-2 p-mb-2" @click="confirm($event)" style="background: black; color: white;">{{
                            $t('notice1.edit.Save')
                    }}</Button>
                    <Button label="Primary" class="p-button-outlined p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black;"><i
                            class="pi pi-replay"></i> {{ $t('notice1.edit.Back') }}</Button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import editInfo from '../../validations/account/EditInfo';
import AdminService from '../../service/API/AdminService';
import PasswordService from '../../service/API/PasswordService';
export default {
    data() {
        return {
            dropdownItems: [
                { name: 'male', code: 'm' },
                { name: 'female', code: 'f' },
            ],
            dropdownItem: null,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,
            products: null,
            selectedProduct: null,
            name: '',
            email: '',
            phone_number: '',
            password: '',
            phone: '',

            // mydata: {
            //     name: '',
            //     uid: '',
            // },
            error: {},
        };
    },
    created() {
        this.passwordService = new PasswordService();
        this.adminService = new AdminService();
    },
    methods: {
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        cancel() {
            this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            setTimeout(() => {
                this.$router.go(-1);
            }, 2000);
        },
        confirm(event) {
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '이대로 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "확인",
                rejectLabel: " 취소",
                accept: () => {
                    let vcheckData = {
                        name: this.name,
                        password: this.password,
                        email: this.email,
                        phone_number: this.phone_number,
                    };
                    console.log(vcheckData);
                    const { isInvalid, error } = editInfo(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                        this.error = {};
                        console.log('pass');
                        this.passwordService.editInfos({ id: this.$route.params.id, name: this.name, email: this.email, password: this.password, phone: this.phone_number }).then((res) => {
                            // this.passwordService
                            //     .editInfos(id : this.$route.params.sub_type_id,this.mydata.name)
                            //     .then((res) => {
                            console.warn(res);
                            localStorage.setItem('AdminName', this.name);
                           
                            this.$router.push({ name: 'Admin Dashboard' });
                            setTimeout(() => {
                                this.$toast.add({ severity: 'info', summary: '확인.', detail: '성공적으로 등록되었습니다.', life: 3000 });
                            }, 500);
                        })
                            .catch((res) => alert(res));
                    }
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다.', detail: '취소되었습니다.', life: 3000 });
                },
            });
        },
    },
    mounted() {

        this.adminService.viewAdmin(this.$route.params.id).then((res) => {
            this.name = res.name;
            this.email = res.email;
            this.phone_number = res.phone_number;

            // localStorage.setItem('desc', result[0].description);
            console.log(res);

        });

    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
</style>
